
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/docs-for-developers",
      function () {
        return require("private-next-pages/books/docs-for-developers.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/docs-for-developers"])
      });
    }
  